import { CacheRepo } from "./CacheRepo";

export class JsonCacheRepo extends CacheRepo<string> {

    constructor() {
        super();
    }

    async get<T>(key: string): Promise<T | null> {
        const cached = await super.get(key);
        return cached ? JSON.parse(cached) : null;
    }

    async set<T>(key: string, data: T, ttl?: number): Promise<void> {
        await super.set(key, JSON.stringify(data), ttl);
    }

    async update<T>(key: string, data: T, ttl?: number): Promise<void> {
        await super.update(key, JSON.stringify(data), ttl);
    }
}